export default __webpack_public_path__ + "static/media/roles_permissions.1c6a1cc8.svg";